/* eslint-disable no-undef */
(function () {
  'use strict'

  angular.module('MktzapApp.Factories')
    .factory('MessagesPortalHistoryService', messagesPortalHistoryService)

  messagesPortalHistoryService.$inject = ['$resource']

  function messagesPortalHistoryService ($resource) {
    return $resource('', {}, {
      getData: {
        url: apiUrl + '/messages-portal/history/search',
        method: 'GET',
        params: {},
        isArray: false
      }
    })
  }
// eslint-disable-next-line semi
})();
